import type { RouteObject } from 'react-router-dom';

import RouterItems from './items';
import RouterMerks from './merks';

const RouterItemManagement: RouteObject[] = [...RouterItems, ...RouterMerks];

export default RouterItemManagement;
